import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 8L19 14.57L17.62 16L12 10.72L6.38 16L5 14.57L12 8Z" fill={ fill || 'currentColor' } />
    </svg>
);
